import React from 'react'
import { connect } from 'react-redux'

import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
// import withMobileDialog from '@material-ui/core/withMobileDialog';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';

import {
  LocalForm,
  Control,
  actions
} from 'react-redux-form'

import {
  // create_skill,
  // update_skill,
  reset_skill
} from '../actions'

import {
  isRequired
} from "../validators"

const mapStateToProps = state => {
  return {
    mustRedirect: state.skill.must_redirect,
    current_user: state.auth.current_user.data
  }
}

const mapDispatchToProps = dispatch => {
  return {
    // createSkill: (values) => dispatch( create_skill(values) ),
    // updateSkill: (id, values) => dispatch( update_skill(id, values) ),
    resetSkill: () => dispatch( reset_skill() ),
  }
}

class ConnectedSkillForm extends React.Component {
  state={
    nameValid: true,
    nameError: null,
    formValid: true
  }

  attachDispatch(dispatch) {
    this.formDispatch = dispatch;
  }

  handleSubmit = (values) => {
    this.props.addSkill(values)
    this.props.resetSkill()
  }

  handleCancel = () => {
    this.props.resetSkill()
    this.props.handleClose()
  }

  handleUpdate = (form) => {
    const {name, $form} = form
    const nameState = (name.pristine || name.valid)

    this.setState({
      nameValid: nameState,
      formValid: $form.valid
    })

  }

  componentDidUpdate(prevProps, prevState) {
    if ( this.props.mustRedirect !== prevProps.mustRedirect && this.props.mustRedirect === true) {
      this.handleCancel()
    }
  }

  render() {
    const {open, current_user} = this.props

    if ( !open || current_user.role !== "admin" ) {
      return ''
    }

    return (
        <Dialog
          open={open}
          aria-labelledby="skill-form"
          className="form-block"
        >
          <DialogTitle id="skill-form">Add new skill</DialogTitle>
          <DialogContent>
            <LocalForm
              model="skill"
              initialState={{name: ''}}
              getDispatch={(dispatch) => this.attachDispatch(dispatch)}
              onSubmit={this.handleSubmit}
              onUpdate={this.handleUpdate}
            >

              <Control
                id="skill-name"
                model="skill.name"
                //label="Skill Name"
                margin="none"
                autoFocus
                fullWidth
                required
                FormHelperTextProps={{
                  classes: {
                    error: 'TextInput-error'
                  }
                }}
                placeholder="Name Of Skill"
                component={TextField}
                error={ !this.state.nameValid || this.props.skillError !== '' }
                helperText={this.state.nameValid ? ((this.props.skillError !== '') ? this.props.skillError : '') :  "Name is required" }
                validators={{
                  required: (val) => {
                    return isRequired(val)
                  }
                }}
              />

            </LocalForm>

          </DialogContent>
          <DialogActions>

            <Button className="c-blue buttonnoto" onClick={ e => {
              e.preventDefault()
              this.handleCancel()
            }} >
              CANCEL
            </Button>

            <Button
              label="Submit"
              aria-label="Submit"
              className="c-blue buttonnoto"
              onClick={e => {
                e.preventDefault()
                this.formDispatch( actions.submit('skill'))
              }}
              >
              OK
            </Button>

          </DialogActions>
        </Dialog>
    );
  }
}

const SkillForm = connect(mapStateToProps, mapDispatchToProps)(ConnectedSkillForm);
export default SkillForm



// WEBPACK FOOTER //
// ./src/js/components/SkillForm.js